export const DEFAULT_MAX_STRING_LENGTH = 256

export const trimAndClamp = (value: string, maxLength?: number) => {
  const trimmed = value.trim()

  if (typeof maxLength !== 'number') {
    return trimmed
  }

  return trimmed.slice(0, maxLength)
}

export const truncateWithEllipsis = (value: string, maxLength = 50) => {
  const trimmed = value.trim()

  if (trimmed.length <= maxLength) {
    return trimmed
  }

  return `${trimmed.slice(0, maxLength)}...`
}

export const getTruncationInfo = (value: string, maxLength = 50) => {
  const trimmed = trimAndClamp(value, DEFAULT_MAX_STRING_LENGTH)
  const truncated = truncateWithEllipsis(trimmed, maxLength)

  return {
    trimmed,
    truncated,
    isTruncated: truncated !== trimmed,
  }
}

